import { clearCalendarSelection } from '../store/selection.store';
import { openCheckout } from './checkout.modal';


let calendarSelectionEl: HTMLTambrCalendarSelectionElement;

export function openSelectionDialog() {
  if ( document.getElementsByTagName('tambr-calendar-selection').length ) return;
  
  calendarSelectionEl = document.createElement('tambr-calendar-selection');

  calendarSelectionEl.addEventListener( 'tambrCalendarSelectionCheckout', () => { 
    calendarSelectionEl.remove();
    openCheckout();
  });

  calendarSelectionEl.addEventListener( 'tambrCalendarSelectionCancel', () => { 
    calendarSelectionEl.remove(); 
    clearCalendarSelection();
  });

  document.body.appendChild( calendarSelectionEl );
}